export var BlockType;
(function (BlockType) {
    BlockType["IMAGE"] = "image";
    BlockType["TEXT"] = "text";
    BlockType["NEW"] = "";
})(BlockType || (BlockType = {}));
